/*
 * @Description: 特材库检验接口
 * @Author: wangwangwang
 * @Date: 2020-12-16 10:17:41
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-22 14:56:19
 */
import request from '@/utils/request'

export const getCheckData1 = '/icps/system/sign/materials/rawCheck/getList';
export const getCheckData2 = '/icps/system/sign/materials/proCheck/getList';
/**
 * @Description: 取样、改变检测结果
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updRawInfo(data) {
  return request({
    url: '/icps/system/sign/materials/rawCheck/updRawInfo',
    method: 'post',
    data
  })
}
/**
 * @Description: 检测录入-原料
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function submitContent(data) {
  return request({
    url: '/icps/system/sign/materials/rawCheck/submitContent',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取检测录入信息
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getcheckedSubmitInfo(data) {
  return request({
    url: '/icps/system/sign/materials/rawCheck/getcheckedSubmitInfo',
    method: 'post',
    data
  })
}

/**
 * @Description: 取样、改变检测结果 2
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updRawInfo2(data) {
  return request({
    url: '/icps/system/sign/materials/proCheck/updProductInfo',
    method: 'post',
    data
  })
}
/**
 * @Description: 检测录入-成品
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function submitContent2(data) {
  return request({
    url: '/icps/system/sign/materials/proCheck/submitContent',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取检测录入信息2
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getcheckedSubmitInfo2(data) {
  return request({
    url: '/icps/system/sign/materials/proCheck/getcheckedSubmitInfo',
    method: 'post',
    data
  })
}

/**
 * @Description: 验收标准
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getAcceptanceCriteria(data) {
  return request({
    url: '/icps/system/sign/materials/paramControl/getAcceptanceCriteria',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取检测结果
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function saveSubmitContent(data) {
  return request({
    url: '/icps/system/sign/materials/rawCheck/saveSubmitContent',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取检测结果
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function saveSubmitContent2(data) {
  return request({
    url: '/icps/system/sign/materials/proCheck/saveSubmitContent',
    method: 'post',
    data
  })
}
/**
 * @Description: 原料入库、复检检验 NG OK 确认
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updRawCheckResult(data) {
  return request({
    url: '/icps/system/sign/materials/rawCheck/updRawCheckResult',
    method: 'post',
    data
  })
}
/**
 * @Description: 成品入库、复检检验 NG OK 确认
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updProductResult(data) {
  return request({
    url: '/icps/system/sign/materials/proCheck/updProductResult',
    method: 'post',
    data
  })
}

